import { Lightning } from "@lightningjs/sdk";
import { FOCUS_TRANSITION } from "../../base/focus";
import { PLAYER_BLUE, playerText } from "./styles";
export function formatPlaybackTime(milliseconds) {
    if (!Number.isFinite(milliseconds) || milliseconds < 0)
        return "00:00:00";
    const seconds = Math.floor(milliseconds / 1000);
    return [
        Math.floor(seconds / 3600),
        Math.floor(seconds / 60) % 60,
        seconds % 60,
    ]
        .map((part) => String(part).padStart(2, "0"))
        .join(":");
}
export class ProgressBar extends Lightning.Component {
    constructor() {
        super(...arguments);
        this._currentTime = 0;
        this._duration = 0;
        this._live = false;
        this._barWidth = ProgressBar.W;
    }
    static _template() {
        return {
            w: this.W,
            h: 60,
            Background: {
                y: 24,
                w: this.W,
                h: 12,
                rect: true,
                color: 0x4dffffff,
                shader: { type: Lightning.shaders.RoundedRectangle, radius: 6 },
            },
            Progress: {
                y: 24,
                w: 0,
                h: 12,
                visible: false,
                rect: true,
                color: 0xffffffff,
                shader: { type: Lightning.shaders.RoundedRectangle, radius: 6 },
                Focus: {
                    w: (w) => w,
                    h: 12,
                    alpha: 0,
                    texture: Lightning.Tools.getCanvasTexture((callback) => {
                        const canvas = document.createElement("canvas");
                        canvas.width = 64;
                        canvas.height = 12;
                        const context = canvas.getContext("2d");
                        const gradient = context.createLinearGradient(0, 0, 64, 0);
                        gradient.addColorStop(0, "#083a96");
                        gradient.addColorStop(0.5, "#085fff");
                        gradient.addColorStop(1, "#083a96");
                        context.fillStyle = gradient;
                        context.fillRect(0, 0, 64, 12);
                        callback(null, canvas);
                    }, "player-progress-gradient"),
                },
            },
            Playhead: {
                y: 30,
                w: 20,
                h: 20,
                mount: 0.5,
                alpha: 0,
                rect: true,
                color: PLAYER_BLUE,
                shader: { type: Lightning.shaders.RoundedRectangle, radius: 10 },
            },
            CurrentTime: {
                y: -14,
                alpha: 0,
                text: Object.assign(Object.assign({}, playerText("", 24, 28)), { w: 110, textAlign: "center" }),
            },
        };
    }
    set currentTime(time) {
        this._currentTime = Number.isFinite(time) ? Math.max(0, time) : 0;
        this.updateProgress();
    }
    set live(live) {
        this._live = live;
        this.patch({
            Playhead: { visible: !live, alpha: 0 },
            CurrentTime: { visible: !live, alpha: 0 },
        });
        this.updateProgress();
    }
    set barWidth(width) {
        this._barWidth = width;
        this.patch({ w: width, Background: { w: width } });
        this.updateProgress();
    }
    set duration(duration) {
        this._duration = Number.isFinite(duration) ? Math.max(0, duration) : 0;
        this.updateProgress();
    }
    updateProgress() {
        const time = this._duration > 0 ? Math.min(this._currentTime, this._duration) : 0;
        const fraction = this._duration > 0 ? time / this._duration : 0;
        const progress = (this._live ? 1 : fraction) * this._barWidth;
        this.patch({
            // Hide the fill at zero to prevent a fallback to the texture's natural width.
            Progress: { w: progress, visible: progress > 0 },
            Playhead: { x: progress },
            CurrentTime: {
                x: Math.max(0, Math.min(this._barWidth - 110, progress - 55)),
                text: { text: formatPlaybackTime(time) },
            },
        });
    }
    _focus() {
        this.tag("Progress.Focus").setSmooth("alpha", 1, FOCUS_TRANSITION);
    }
    _unfocus() {
        this.tag("Progress.Focus").setSmooth("alpha", 0, FOCUS_TRANSITION);
        this.tag("Playhead").setSmooth("alpha", 0, FOCUS_TRANSITION);
        this.tag("CurrentTime").setSmooth("alpha", 0, FOCUS_TRANSITION);
    }
    _handleEnter() {
        this.signal("togglePlayback");
        return true;
    }
    _handleLeft() {
        this.seek(-10000);
        return true;
    }
    _handleRight() {
        this.seek(10000);
        return true;
    }
    seek(delta) {
        if (this._live || this._duration <= 0)
            return;
        // Keep the resting bar clean, while retaining precise feedback when seeking.
        this.patch({ Playhead: { alpha: 1 }, CurrentTime: { alpha: 1 } });
        this.signal("seek", delta);
    }
}
ProgressBar.W = 1477;
export default ProgressBar;
//# sourceMappingURL=ProgressBar.js.map